import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  private visibility = new BehaviorSubject<boolean>(true);
  navbarVisibility$ = this.visibility.asObservable();

  show() {
    this.visibility.next(true);
  }

  hide() {
    this.visibility.next(false);
  }
}
